var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "notification-slide" } }, [
    _vm.visible
      ? _c(
          "div",
          {
            staticClass: "alert mt-0",
            class: [_vm.alertClass, _vm.positionClass],
            attrs: { role: "alert" },
          },
          [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: {
                  "data-alert-close": "",
                  type: "button",
                  "aria-label": "Close",
                },
                on: { click: _vm.dismiss },
              },
              [_vm._v(" × ")]
            ),
            _vm.message
              ? _c(
                  "span",
                  { staticClass: "message" },
                  [
                    _c("omegaup-markdown", {
                      attrs: { markdown: _vm.message },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }